
import { Component, Vue } from "vue-property-decorator";
import { AreaTreeContent } from "@/types/sv-data/area-tree/AreaTreeContent";
import api from '@/services/api.service';

@Component({
})
export default class DrawdownBreadcrumbs extends Vue {
    public breadcrumbs: AreaTreeContent[] = [];

	public async constructBreadcrumb(selectedNodeId: number, requiredPermissions: string[]): Promise<void> {
		var breadcrumbs = await api.getGroupPathToRoot(selectedNodeId, requiredPermissions);
		this.breadcrumbs = breadcrumbs.map(group => ({groupId: group.groupID, label: group.title}));
	}

    private trimBreadcrumbs(index: number): void {
		this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
		this.emitLastBreadcrumb()
	}

	private ascendBreadcrumbs(): void {
		this.breadcrumbs.pop();
		this.emitLastBreadcrumb()
	}

	private clearBreadcrumbs(): void {
		if (this.breadcrumbs.length > 1) {
			this.breadcrumbs.splice(1);
		}
		this.emitLastBreadcrumb()
	}

	private getLastItemInBreadcrumbs(): AreaTreeContent {
		var breadcrumb = null;
		if(this.breadcrumbs.length > 0) {
			breadcrumb = this.breadcrumbs[this.breadcrumbs.length -1]
		}

		return breadcrumb;
	}

	private emitLastBreadcrumb(): void {
		this.$emit("pin-node", this.getLastItemInBreadcrumbs()?.groupId);
	}

	public get lowestLevelOfBreadcrumbs(): AreaTreeContent {
		return this.getLastItemInBreadcrumbs();
	}
}
